export default "__VITE_ASSET__CcvpFGLB__"